//# sourceMappingURL=icons.mjs.map
/// <reference types="./icons.d.mts" />
import * as $css from "../../sketch/sketch/css.mjs";
import * as $length from "../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../sketch/sketch/css/length.mjs";
import * as $h from "../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $add from "../ds/icons/add.mjs";
import * as $add_user from "../ds/icons/add_user.mjs";
import * as $align_center from "../ds/icons/align_center.mjs";
import * as $align_justify from "../ds/icons/align_justify.mjs";
import * as $align_left from "../ds/icons/align_left.mjs";
import * as $align_right from "../ds/icons/align_right.mjs";
import * as $archive from "../ds/icons/archive.mjs";
import * as $arrow_down_line from "../ds/icons/arrow_down_line.mjs";
import * as $arrow_dropdown from "../ds/icons/arrow_dropdown.mjs";
import * as $arrow_left_line from "../ds/icons/arrow_left_line.mjs";
import * as $arrow_right_line from "../ds/icons/arrow_right_line.mjs";
import * as $arrow_up_line from "../ds/icons/arrow_up_line.mjs";
import * as $assign from "../ds/icons/assign.mjs";
import * as $at_line from "../ds/icons/at_line.mjs";
import * as $attachment from "../ds/icons/attachment.mjs";
import * as $barchart from "../ds/icons/barchart.mjs";
import * as $bell from "../ds/icons/bell.mjs";
import * as $bold from "../ds/icons/bold.mjs";
import * as $book from "../ds/icons/book.mjs";
import * as $building from "../ds/icons/building.mjs";
import * as $calendar from "../ds/icons/calendar.mjs";
import * as $check from "../ds/icons/check.mjs";
import * as $check_in_a_box from "../ds/icons/check_in_a_box.mjs";
import * as $checkmark from "../ds/icons/checkmark.mjs";
import * as $clock from "../ds/icons/clock.mjs";
import * as $cmd from "../ds/icons/cmd.mjs";
import * as $collage from "../ds/icons/collage.mjs";
import * as $comment from "../ds/icons/comment.mjs";
import * as $component from "../ds/icons/component.mjs";
import * as $copy from "../ds/icons/copy.mjs";
import * as $cross from "../ds/icons/cross.mjs";
import * as $database from "../ds/icons/database.mjs";
import * as $document from "../ds/icons/document.mjs";
import * as $document_edit from "../ds/icons/document_edit.mjs";
import * as $documentation from "../ds/icons/documentation.mjs";
import * as $dot_list from "../ds/icons/dot_list.mjs";
import * as $double_check_in_a_box from "../ds/icons/double_check_in_a_box.mjs";
import * as $double_checkmark from "../ds/icons/double_checkmark.mjs";
import * as $double_fill from "../ds/icons/double_fill.mjs";
import * as $down_arrow from "../ds/icons/down_arrow.mjs";
import * as $draft from "../ds/icons/draft.mjs";
import * as $edit_line from "../ds/icons/edit_line.mjs";
import * as $editor_menu from "../ds/icons/editor_menu.mjs";
import * as $emoji from "../ds/icons/emoji.mjs";
import * as $export from "../ds/icons/export.mjs";
import * as $external_link from "../ds/icons/external_link.mjs";
import * as $eye from "../ds/icons/eye.mjs";
import * as $file from "../ds/icons/file.mjs";
import * as $filters from "../ds/icons/filters.mjs";
import * as $folder from "../ds/icons/folder.mjs";
import * as $form from "../ds/icons/form.mjs";
import * as $gear from "../ds/icons/gear.mjs";
import * as $globe from "../ds/icons/globe.mjs";
import * as $grab from "../ds/icons/grab.mjs";
import * as $highlight from "../ds/icons/highlight.mjs";
import * as $image from "../ds/icons/image.mjs";
import * as $index_list from "../ds/icons/index_list.mjs";
import * as $info from "../ds/icons/info.mjs";
import * as $italic from "../ds/icons/italic.mjs";
import * as $left_arrow from "../ds/icons/left_arrow.mjs";
import * as $lightbulb_flash from "../ds/icons/lightbulb_flash.mjs";
import * as $link from "../ds/icons/link.mjs";
import * as $list_check from "../ds/icons/list_check.mjs";
import * as $list_height from "../ds/icons/list_height.mjs";
import * as $list_ordered from "../ds/icons/list_ordered.mjs";
import * as $list_unordered from "../ds/icons/list_unordered.mjs";
import * as $loader from "../ds/icons/loader.mjs";
import * as $lock from "../ds/icons/lock.mjs";
import * as $logout from "../ds/icons/logout.mjs";
import * as $longer from "../ds/icons/longer.mjs";
import * as $magnifying_glass from "../ds/icons/magnifying_glass.mjs";
import * as $maintenance from "../ds/icons/maintenance.mjs";
import * as $map from "../ds/icons/map.mjs";
import * as $menu from "../ds/icons/menu.mjs";
import * as $message from "../ds/icons/message.mjs";
import * as $minus from "../ds/icons/minus.mjs";
import * as $more from "../ds/icons/more.mjs";
import * as $notification_badge from "../ds/icons/notification_badge.mjs";
import * as $paper_plane from "../ds/icons/paper_plane.mjs";
import * as $picture_add from "../ds/icons/picture_add.mjs";
import * as $price_tag from "../ds/icons/price_tag.mjs";
import * as $proposal_file from "../ds/icons/proposal_file.mjs";
import * as $question_mark from "../ds/icons/question_mark.mjs";
import * as $quote from "../ds/icons/quote.mjs";
import * as $refresh_line from "../ds/icons/refresh_line.mjs";
import * as $remove_format from "../ds/icons/remove_format.mjs";
import * as $reply from "../ds/icons/reply.mjs";
import * as $right_arrow from "../ds/icons/right_arrow.mjs";
import * as $shining from "../ds/icons/shining.mjs";
import * as $shorter from "../ds/icons/shorter.mjs";
import * as $sparkles from "../ds/icons/sparkles.mjs";
import * as $table_line from "../ds/icons/table_line.mjs";
import * as $tools from "../ds/icons/tools.mjs";
import * as $translate from "../ds/icons/translate.mjs";
import * as $trash from "../ds/icons/trash.mjs";
import * as $underline from "../ds/icons/underline.mjs";
import * as $up_arrow from "../ds/icons/up_arrow.mjs";
import * as $upload from "../ds/icons/upload.mjs";
import * as $user from "../ds/icons/user.mjs";
import { toList } from "../gleam.mjs";

export const add = $add.add;

export const add_user = $add_user.add_user;

export const align_center = $align_center.align_center;

export const align_jusitfy = $align_justify.align_jusitfy;

export const align_left = $align_left.align_left;

export const align_right = $align_right.align_right;

export const archive = $archive.archive;

export const arrow_down_line = $arrow_down_line.arrow_down_line;

export const arrow_dropdown = $arrow_dropdown.arrow_dropdown;

export const arrow_left_line = $arrow_left_line.arrow_left_line;

export const arrow_right_line = $arrow_right_line.arrow_right_line;

export const arrow_up_line = $arrow_up_line.arrow_up_line;

export const assign = $assign.assign;

export const at_line = $at_line.at_line;

export const attachment = $attachment.attachment;

export const barchart = $barchart.barchart;

export const bell = $bell.bell;

export const bold = $bold.bold;

export const book = $book.book;

export const building = $building.building;

export const calendar = $calendar.calendar;

export const check = $check.check;

export const check_in_a_box = $check_in_a_box.check_in_a_box;

export const checkmark = $checkmark.checkmark;

export const clock = $clock.clock;

export const cmd = $cmd.cmd;

export const collage = $collage.collage;

export const component = $component.component;

export const copy = $copy.copy;

export const cross = $cross.cross;

export const database = $database.database;

export const comment = $comment.comment;

export const document = $document.document;

export const document_edit = $document_edit.document_edit;

export const documentation = $documentation.documentation;

export const dot_list = $dot_list.dot_list;

export const double_check_in_a_box = $double_check_in_a_box.double_check_in_a_box;

export const double_checkmark = $double_checkmark.double_checkmark;

export const double_fill = $double_fill.double_fill;

export const down_arrow = $down_arrow.down_arrow;

export const draft = $draft.draft;

export const edit_line = $edit_line.edit_line;

export const editor_menu = $editor_menu.editor_menu;

export const emoji = $emoji.emoji;

export const export$ = $export.export$;

export const external_link = $external_link.external_link;

export const eye = $eye.eye;

export const file = $file.file;

export const filters = $filters.filters;

export const folder = $folder.folder;

export const form = $form.form;

export const gear = $gear.gear;

export const globe = $globe.globe;

export const grab = $grab.grab;

export const highlight = $highlight.highlight;

export const image = $image.image;

export const index_list = $index_list.index_list;

export const info = $info.info;

export const italic = $italic.italic;

export const left_arrow = $left_arrow.left_arrow;

export const lightbulb_flash = $lightbulb_flash.lightbulb_flash;

export const link = $link.link;

export const list_check = $list_check.list_check;

export const list_height = $list_height.list_height;

export const list_ordered = $list_ordered.list_ordered;

export const list_unordered = $list_unordered.list_unordered;

export const loader = $loader.loader;

export const lock = $lock.lock;

export const logout = $logout.logout;

export const longer = $longer.longer;

export const magnifying_glass = $magnifying_glass.magnifying_glass;

export const maintenance = $maintenance.maintenance;

export const map = $map.map;

export const menu = $menu.menu;

export const message = $message.message;

export const minus = $minus.minus;

export const more = $more.more;

export const notification_badge = $notification_badge.notification_badge;

export const paper_plane = $paper_plane.paper_plane;

export const picture_add = $picture_add.picture_add;

export const price_tag = $price_tag.price_tag;

export const proposal_file = $proposal_file.proposal_file;

export const question_mark = $question_mark.question_mark;

export const quote = $quote.quote;

export const refresh_line = $refresh_line.refresh_line;

export const remove_format = $remove_format.remove_format;

export const reply = $reply.reply;

export const right_arrow = $right_arrow.right_arrow;

export const shining = $shining.shining;

export const shorter = $shorter.shorter;

export const sparkles = $sparkles.sparkles;

export const table_line = $table_line.table_line;

export const tools = $tools.tools;

export const translate = $translate.translate;

export const trash = $trash.trash;

export const underline = $underline.underline;

export const up_arrow = $up_arrow.up_arrow;

export const upload = $upload.upload;

export const user = $user.user;

function flex() {
  return $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.justify_content("center"),
      $css.flex_shrink(0.0),
    ]),
  );
}

function square(size) {
  return $css.class$(
    toList([$css.width(px(size)), $css.height(px(size)), $css.flex_shrink(0.0)]),
  );
}

/**
 * 36x36
 */
export function large(icon) {
  let _pipe = $css.class$(
    toList([
      $css.compose(square(36)),
      $css.compose(flex()),
      $css.selector(
        " > svg",
        toList([$css.width(percent(100)), $css.height(percent(100))]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

/**
 * 24x24
 */
export function medium(icon) {
  let _pipe = $css.class$(
    toList([
      $css.compose(square(24)),
      $css.compose(flex()),
      $css.selector(
        " > svg",
        toList([$css.width(percent(100)), $css.height(percent(100))]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

/**
 * 20x20
 */
export function small(icon) {
  let _pipe = $css.class$(
    toList([
      $css.compose(square(20)),
      $css.compose(flex()),
      $css.selector(
        " > svg",
        toList([$css.width(percent(100)), $css.height(percent(100))]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

/**
 * 16x16
 */
export function tiny(icon) {
  let _pipe = $css.class$(
    toList([
      $css.compose(square(16)),
      $css.compose(flex()),
      $css.selector(
        " > svg",
        toList([$css.width(percent(100)), $css.height(percent(100))]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

/**
 * 14x14
 */
export function very_tiny(icon) {
  let _pipe = $css.class$(
    toList([
      $css.compose(square(14)),
      $css.compose(flex()),
      $css.selector(
        " > svg",
        toList([$css.width(percent(100)), $css.height(percent(100))]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}

/**
 * 12x12
 */
export function minuscule(icon) {
  let _pipe = $css.class$(
    toList([
      $css.compose(square(12)),
      $css.compose(flex()),
      $css.selector(
        " > svg",
        toList([$css.width(percent(100)), $css.height(percent(100))]),
      ),
    ]),
  );
  return $h.div(_pipe, toList([]), toList([icon]));
}
